import React from 'react';
import Slider from 'react-slick';
import { Link, useNavigate } from 'react-router-dom';
import BookNowButton from '../Button/BookNowButton';
import { useSelector } from 'react-redux';
import { slugify } from 'Utils/Functions';

const PopularLabTests = ({ data, heading, showViewAll }) => {
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.loader);
  let { cityName } = useSelector((state) => state.location);
  cityName = slugify(cityName);

  const settings = {
    arrows: data?.length > 5 ? true : false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,

    infinite: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 1057,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      }
    ]
  };

  const handleNavigation = (id, event) => {
    navigate(`/${cityName}/blood-tests/${id}`);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="section-heading">
            <h2>{heading}</h2>
            {showViewAll && (
              <Link
                className={`viewall-btn ${
                  data?.length <= 5 && 'remove-margin-left'
                }`}
                to={`/${cityName}/blood-tests?popular-lab-tests=true`}
              >
                View All
              </Link>
            )}
          </div>
        </div>

        <div className="col-12">
          {data?.length > 0 ? (
            <Slider
              {...settings}
              className="popular-lab-test-content"
            >
              {data?.map((item) => (
                <div
                  onClick={() => handleNavigation(item?.service_slug)}
                  className="popular-lab-card"
                  key={item.service_id + 100}
                >
                  {item?.discount_percentage !== 0 && (
                    <div className="price-tag">
                      <span>{Math.floor(item?.discount_percentage)}% off</span>
                    </div>
                  )}
                  <h3
                    className="ellipsis-two-lines"
                    data-tooltip-id={'my-tooltip'}
                    data-tooltip-content={`${item?.service_name}`}
                    data-tooltip-place="top"
                  >
                    {item?.service_name}
                  </h3>
                  <p>{item?.no_of_test_include} {item?.no_of_test_include > 1 ? 'Parameters' : 'Parameter'}</p>
                  <div className="price">
                    <em class="price-icon-orange-big">₹</em>
                    {item?.total_amount}
                    {item?.mrp_amount !== item?.total_amount && (
                      <span>₹{item?.mrp_amount ?? 0}</span>
                    )}
                  </div>
                  <div className="text-start">
                    <BookNowButton id={item?.service_id} />
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            !loading && <h3 className="text-center">No Data Found</h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopularLabTests;
